import { render } from "./banner.vue?vue&type=template&id=45ff829a&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=45ff829a&lang=scss&scoped=true"

import exportComponent from "/data/sg-h5/panther-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ff829a"]])

export default __exports__